const mutations = {
  mutationLevels(state, payload) {
    state.levels = payload;
  },

  mutationLevel(state, payload) {
    state.level = payload;
  },
};

export default mutations;
